import { useTableInstance } from '../../components/TableContext/TableContext.esm.js';
import '../../components/TableContext/TableProvider.esm.js';

/**
 * This hook will return the data for rows that have been selected.
 */
function useSelectedRowData() {
    var tableInstance = useTableInstance();
    var selectedRows = Object.keys(tableInstance.state.selectedRowIds);
    var data = selectedRows.map(function (index) { return tableInstance.data[Number(index)]; });
    return data;
}

export { useSelectedRowData };
//# sourceMappingURL=useSelectedRowData.esm.js.map
